import React from "react";
import Section from "./Section/Section";
import "./Resources.css";
import Subjects from "./Subject/Subject";
const Resources = () => {
  const Resources = [
    {
      Theme: "Geoemtry",
      Bgcolor: "#da6923",
      Fcolor: "#fffaf0bd",
      Dis: "Elementary Geometry, your first step into the beauty of Olympiad-style thinking.",
      ananas: [
        {
          topic: "Fundamentals",
          finished: 150,
          preview:
            "Geometry begins with fundamental concepts like triangles, angles, lines and concyclic points—each forming the basis of deeper geometric reasoning.",
        },
        {
          topic: "Classical",
          finished: 150,
          preview:
            "Classical geometry tools like Power of a Point and plan transformations are powerful tools, solving complex problems with elegant constructions.",
        },
        {
          topic: "Special Configurations 1",
          finished: 150,
          preview: `Special configurations in a triangle reveal fascinating geometrical arguments, that sometimes are the core of the solution.`,
        },
        {
          topic: "Special Configurations 2",
          finished: 150,
          preview:
            "Special configurations in a circle reveal fascinating geometrical arguments, that sometimes are the core of the solution.",
        },
        {
          topic: "Harmonic Bundels",
          finished: 150,
          preview:
            "This unit presents  a configuration of four lines (or four points on a line) such that the cross-ratio of the four is equal to –1, representing a special projective invariance.",
        },
      ],
    },
    {
      Theme: "Combinatorics",
      Bgcolor: "#1E3A8A",
      Fcolor: "#fffaf0bd",
      Dis: "Combinatorics, unlocking the secrets of counting and arrangement in Olympiad-style problems.",
      ananas: [
        {
          topic: "Sets and Counting",
          finished: 150,
          preview:
            "Learn the foundations of combinatorics with sets, subsets, and essential counting techniques and formula's.",
        },
        {
          topic: "The Pigeonhole Principle",
          finished: 150,
          preview:
            "Master this deceptively simple yet powerful principle to prove the inevitability of certain outcomes in combinatorial setups.",
        },
        {
          topic: "Induction",
          finished: 150,
          preview:
            "Use mathematical induction to prove statements recursively, building step-by-step arguments that withstand all cases.",
        },
        {
          topic: "Invariant-Monovariant",
          finished: 150,
          preview:
            "Explore clever problem-solving techniques that rely on fixed or steadily changing quantities to reach conclusions.",
        },
        {
          topic: "Graph Theory",
          finished: 150,
          preview:
            "Dive into vertices, edges, and structures like trees and cycles to uncover relationships in discrete systems.",
        },
      ],
    },
    {
      Theme: "Number Theory",
      Bgcolor: "#6A8D92",
      Fcolor: "#fffaf0bd",
      Dis: "Number Theory, where the elegance of primes guides you through Olympiad challenges.",
      ananas: [
        {
          topic: "Fundamentals",
          finished: 150,
          preview:
            "Start your journey with integers, divisibility, primes, and the essential building blocks of number theory.",
        },
        {
          topic: "Classical Modular Arithmetic",
          finished: 150,
          preview:
            "Understand congruences, modular operations, and classical results like Fermat’s and Euler’s theorems.",
        },
        {
          topic: "Diophantine Equations",
          finished: 150,
          preview:
            "Tackle equations with integer solutions using clever tricks, factorizations, and bounding arguments.",
        },
        {
          topic: "Advanced Modular Arithmetic",
          finished: 150,
          preview:
            "Dive into deeper tools like primitive roots, orders, and advanced modular inverses in number theory.",
        },
        {
          topic: "Advanced Tools",
          finished: 150,
          preview:
            "Discover number-theoretic functions, the Chinese Remainder Theorem, and powerful techniques for Olympiad problems.",
        },
      ],
    },
    {
      Theme: "Algebra",
      Bgcolor: "#3E000C",
      Fcolor: "#fffaf0bd",
      Dis: "Algebra, the foundation of problem-solving with equations and structures in the Olympiad world.",
      ananas: [
        {
          topic: "Fundamentals",
          finished: 150,
          preview:
            "Review the basics of algebra—equations, inequalities, and identities—that power Olympiad problem solving.",
        },
        {
          topic: "Sequences & Sums",
          finished: 150,
          preview:
            "Explore real sequences, telescoping sums, and clever techniques for evaluating series.",
        },
        {
          topic: "Polynomials",
          finished: 150,
          preview:
            "Dive into polynomial roots, factorization, and identities like Vieta’s formulas to tackle rich algebraic challenges.",
        },
        {
          topic: "Functions",
          finished: 150,
          preview:
            "Understand functions as mappings, explore injectivity, surjectivity, and composition to decode functional equations.",
        },
        {
          topic: "Inequalities",
          finished: 150,
          preview:
            "Explore advanced inequalities like Rearrangement, Chebyshev, and Muirhead to master symmetric and ordered expressions.",
        },
      ],
    },
  ];

  return (
    <div className="Resource">
      
      <div className="Headers">
        {/*<h1>Introduction</h1>
        <p>
          Welcome to the Resources section—your companion for exploring the
          world of Olympiad mathematics!
        </p>
        <p>
          In this section, you'll find a series of units covering Geometry,
          Combinatorics, Number Theory, and Algebra. Each unit features concept
          overviews, students' lecture notes and a list of graded problem sets.
  </p>*/}       {/* <p>
          These resources were created by a student who participated in Math
          Olympiads. The structure may not follow a traditional textbook
          format—they're sketched as the author personally understood and
          internalized the ideas, aiming to make them as intuitive and
          accessible as possible.
        </p>
        <h4>Submissions :</h4>{" "}
        <p>
          For clarity and consistency, PDF solutions written using LaTeX are
          strongly preferred. You may use{" "}
          <a href="https://www.overleaf.com/latex/templates">Overleaf</a> as a
          text-editor and make use of this <a href="">Guide</a>.
        </p>
  <hr />*/}
  <div className="TileNdictinnaire">
  <h1>Your Units : </h1>
<button onClick={() => {
    window.open("https://drive.google.com/file/d/19Ang_oo3GO4aaVxz3YA1_O7o24jP97is/view?usp=sharing", "_blank"); 
    // "_blank" opens in a new tab/fenetre
  }}>Dictionary</button>
  </div>
        
        <div className="NB">
          {" "}
          📌 Note: The structure may not follow a traditional textbook
          format—they're sketched as the author personally understood and
          internalized the ideas
          <br />
          <br />
          📌 Note: In this section, you'll find a series of units covering Geometry,
          Combinatorics, Number Theory, and Algebra.
          <br /> 
          <br />
          📌 Note: These units are ordered from easiest to hardest, following
          the natural progression of difficulty.
        </div>
        <hr />
      </div>

      <div className="Resources-container">
        <Subjects/>
      </div>
    </div>
  );
};

export default Resources;
